import axios, { AxiosError } from "axios";
import { collection, getDocs, query, where  } from "firebase/firestore";
import { fsDb } from '../../firebase/config';

export default class apiProjects {

    static getProjects = async () => {
        // let response = null;
        try {
            const { data } = await axios.get('/assets/data/projects.json');            
            return data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                handleAxiosError(error);
            } else {
                handleUnexpectedError(error);
            }
        }
    }


    static getProjectById = async (key:string) => {
        // let response = null;
        try {
            const { data } = await axios.get('/assets/data/projects.json');
            return data[key];
        } catch (error) {
            if (axios.isAxiosError(error)) {
                handleAxiosError(error);
            } else {
                handleUnexpectedError(error);
            }
        }
    }

    static getfbProjects = async () => {
        let response = [];
        const querySnapshot = await getDocs(collection(fsDb, "dev/tables/projects"));
        querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`);
            let dbDoc = doc.data();
            dbDoc.id = doc.id;
            response.push(dbDoc)
        });
        return response;
    }

    static getAssetByQuery = async (docId: string) => {
        let response = [];
        // console.log('📌 🟢 getAssetByQuery= 🟢 docId', docId);
        const dbRef = collection(fsDb, "dev/tables/media");
        const result = query(dbRef, where("fKey", "==", docId));
        const querySnapshot = await getDocs(result);
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            let dbDoc = doc.data();
            dbDoc.id = doc.id;
            response.push(dbDoc)
        });
        // console.log(response[0]);
        return response[0];
    }
}

function handleAxiosError(error: AxiosError<any>) {
    throw new Error("Function not implemented.");
}
function handleUnexpectedError(error: unknown) {
    throw new Error("Function not implemented.");
}

